/** @jsx h */

import { h } from 'preact';
import { PropTypes } from 'preact-compat';
import style from './style.scss';
import { langPack } from '../../../utils/langPack';
import noUserImage from '../../../assets/nouserimage.jpg';

const Chat = (props) => {
  const {
    users = {}, isConnected, locale, badges: { badges },
  } = props;

  const onChangePerson = (person) => () => props.chooseChatPerson(person);

  const renderUnreadItem = (el) => {
    if (el.missedMessage + el.missedCall) {
      const id = el.toID;
      const user = el.toUser || users[id];
      const { avatarUrl, nickname ='' } = user || {};
      const fullName = nickname;
      return (
        // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
        <li key={user.id} onClick={onChangePerson(el)} onKeyPress={onChangePerson(el)}>
          <div className={style.avatar}>
            { avatarUrl ? (
              <img src={avatarUrl} alt={fullName} title={fullName} />
            ) : (
              <img src={noUserImage} alt={fullName} title={fullName} />
            )}
          </div>
          <div className={style.msgCount}>{el.missedMessage + el.missedCall}</div>
          <div className={style.authorName}>{fullName}</div>
        </li>
      );
    }
    return null;
  };
  return (
    <div className={style.chatComponent}>
      { !isConnected && (
      <div className={style.connectingDiv}>
        <div className={style.ldsDefault}>
          <div />
          <div />
          <div />
          <div />
          <div />
          <div />
          <div />
          <div />
          <div />
          <div />
          <div />
          <div />
          <div>{langPack[locale].MISC.CONNECTING}</div>
        </div>
      </div>
      )}

      { badges && (
      <ul className={style.users}>
        {Object.keys(badges).map((el) => renderUnreadItem(badges[el]))}
      </ul>
      ) }
    </div>
  );
};

Chat.propTypes = {
  isConnected: PropTypes.bool.isRequired,
  locale: PropTypes.string.isRequired,
  badges: PropTypes.shape({
    badges: PropTypes.shape({}),
  }).isRequired,
  chooseChatPerson: PropTypes.func.isRequired,
  users: PropTypes.shape({}).isRequired,
};

export default Chat;



// WEBPACK FOOTER //
// ./components/communication/chat/index.js